export default "__VITE_PUBLIC_ASSET__974f6053__"